<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :footer-props="datatable_footer"
            :options.sync="table_options"
            :server-items-length="total"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:top>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <autocomplete
                        ref="autocomplete"

                        :get-result-value="getResultValue"
                        :search="search"
                        @submit="onSubmit"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                    >
                      <v-btn
                        class="ma-0"
                        color="primary"
                        outlined
                        @click="onOpenFilter"
                      >
                        <v-icon class="ml-3">
                          mdi-filter-variant
                        </v-icon>
                        <span class="mx-3">ФИЛЬТРЫ</span>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                      class="d-flex justify-md-end"
                    >
                      <v-btn
                        color="secondary"
                        outlined
                        class="ma-0"
                        @click="onDownloadReport"
                      >
                        <v-icon class="ml-3">
                          mdi-download
                        </v-icon>
                        <span class="mx-3">Выгрузить</span>
                      </v-btn>
                      <v-icon
                        medium
                        class="icon-table"
                        @click="onOpenHeader"
                      >
                        mdi-table-cog
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <div>
                      <v-chip
                        v-for="(filter, index) in filterStuff"
                        v-show="filter.fieldTitle !== '' "
                        :key="'i' + index"
                        close
                        @click:close="onClearFilter(filter)"
                      >
                        <span>{{ filter.fieldTitle }}</span>
                      </v-chip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.operation="{ item }">
              <v-chip
                :color="item.operation.color"
              >
                {{ item.operation.text }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="item.status.color"
              >
                {{ item.status.text }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-visible="headerDialogVisible"
          :dialog-headers="dialogHeaders"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TransactionModel, TransactionHeadersModel, TransactionTitlesModel } from "../../models/transaction.model"
import WebApi from "../../shared/modules/web_api"
import {
  downloadCsvFile,
  getCsvFile,
  getObjectsForSearching,
  getSearchedObjects
} from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import { clearFilter, FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import { ServicePointService } from "@/views/loyalty/shared/services/service_point_service"
import { ParticipantService } from "@/views/loyalty/shared/services/participant_service"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"
import { CampaignService } from "@/views/loyalty/shared/services/campaign-service"
import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"

export default {
  name: "TransactionList",
  campaigns: [],
  components: { Autocomplete, FilterDialog, HeaderDialog },
  data: () => ({
      customerNumber: null,
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialogHeaders: [],
    filterDialogVisible: false,
    filterLabel: 'transaction.filter',
    filterStuff: [],
    headerDialogVisible: false,
    headers: [],
    headerService: null,
    justpayClientService: null,
    participants: [],
    products: [],
    role: 0,
    servicePoints: [],
    searchStuff: null,
    table_options: {},
    total: 0,
    transactions: [],
    userProfile: null,
    webApi: null
  }),
  watch: {
    table_options: {
      async handler () {
        console.log(this.table_options)
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        this.transactions = await this.getItems()
      },
      deep: true,
    },
  },
  async beforeMount () {
    this.role = +this.$route.params.role
    const campaignService = new CampaignService()
    const justpayNomenclatureService = new JustpayNomenclature()
    this.userProfile = new Userprofile()
    // get list of service points
    const result = await this.axios.post(`${process.env.VUE_APP_JUSTPAY_URL}api/point/list`, {
      id: null,
      page: 1,
      limit: -1
    })
    console.log('result', result)
    if (!result.data.error) {
      const servicePointService = new ServicePointService().add_point_clients(result.data.clients)
          .add_point_places(result.data.places)
      this.servicePoints = result.data.data.map(m => {
        servicePointService.add_point_data(m)
        return servicePointService.item
      })
      console.log('servicePoints', this.servicePoints)
    }
    let users = await this.axios.post(`${process.env.VUE_APP_JUSTPAY_URL}api/user/list`, { id: null, page: 1, limit: -1 })
    console.log('users', users)
    if (!users.data.error) {
      // Resolve Participant Id to Full Name
      const participantService = new ParticipantService()
      this.participants = users.data.data.map(m => {
        participantService.add_data(m)
        return participantService.item
      })
      console.log('participants', this.participants)
    }
    if (this.role === 1) {
      users = await this.userProfile.getUserProfileAll()
      // console.log('users', users)
      const participantService = new ParticipantService()
      const userProfiles = users.map(m => {
        participantService.add_data(m)
        return participantService.item
      })
      this.participants = [...this.participants, ...userProfiles]
      console.log('participants', this.participants)
        const campaigns = await campaignService.getAllCampaigns()
        this.campaigns = campaigns.items
      console.log('this.campaigns', this.campaigns)
      this.products = await justpayNomenclatureService.getNomenclatures()
    }
    if (this.role === 2) {
      // Resolve UserProfile Id to Full Name
      console.log('this.$store.state', this.$store.state)
      this.customerId = this.$store.state.client.id
        this.justpayClientService = new JustpayClient()
        this.customerNumber = await this.justpayClientService.getClientNumber(this.customerId)
      users = await this.userProfile.getUserProfileListByCustomerIdAll(this.customerId)
      console.log('users', users)
      const participantService = new ParticipantService()
      const userProfiles = users.items.map(m => {
        participantService.add_data(m.UserProfileInDb)
        return participantService.item
      })
        // console.log('userProfiles', userProfiles)
      this.participants = [...this.participants, ...userProfiles]
      // console.log('participants', this.participants)
      const campaigns = await campaignService.getCampaignsByCustomerId(this.customerId)
        this.campaigns = campaigns.items
      // console.log('this.campaigns', this.campaigns)
      // get lis of nomenclature code (product code)
      this.products = await justpayNomenclatureService.getNomenclaturesByCustomerId(this.customerId)
    }
    /// /////////////////////////////////////
    localStorage.removeItem(this.filterLabel)
    this.headerService = new HeaderService(TransactionHeadersModel)
    this.webApi = new WebApi().readError("Ошибка при чтении данных")
    const data = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/transaction/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
    console.log('header data', data)
    this.dialogHeaders = this.headerService.get_header(data)
    console.log('that.dialogHeaders', this.dialogHeaders)
    this.headers = this.headerService.get_header_list(data)
    console.log('that.headers', this.headers)

    this.fillFilterStuff()
    this.fillSearchStuff()
    this.transactions = await this.getItems()
    // console.log('this.transactions', this.transactions)
  },
  methods: {
    createItem () {
      this.$router.push({ name: "TransactionCustomerEditLink" })
    },
    onDownloadReport () {
      console.log("transaction", this.transactions)
      let csv =
          "Счёт по дебету;Счёт по кредиту;ИД программы лояльности;Сумма,Период обнуления бонусов;Тип операции;Код товара;" +
          "Дата создания;Ид правила;Алгоритм расчёта;Перод начала действия бонусов;Статус транзакции;ИД транзакции;" +
          "Дата обновления;ИД записи;\n"
      csv += getCsvFile(this.transactions)
      console.log("csv", csv)
      downloadCsvFile("ReportTransaction", csv)
    },
    fillFilterStuff () {
      this.filterStuff = new FilterStuff()
      TransactionTitlesModel.forEach(item => this.filterStuff.add(new FilterItem().fieldKey(item.value).fieldName(item.text).fieldValue("").fieldType(item.filterType).fieldValues(item.filterValues).fieldMoney().fieldDate().fieldTitle("").value))
      this.filterStuff = this.filterStuff.items
      // add servicePoint names for list in FilterDialog
      this.filterStuff = this.filterStuff.map(fs => {
        return fs.fieldKey === 'servicePointId'
            ? { ...fs, fieldGroupValues: this.servicePoints.map(sp => Object.fromEntries([['text', sp.name], ['value', sp.pointId]])) } : fs
      }).map(camp => {
        return camp.fieldKey === 'campaignId'
            ? { ...camp, fieldGroupValues: this.campaigns.map(sp => Object.fromEntries([['text', sp.name], ['value', sp.campaignId]])) } : camp
      }).map(fs => {
        return fs.fieldKey === 'productCode'
            ? { ...fs, fieldGroupValues: this.products.map(product => Object.fromEntries([['text', product.name], ['value', product.code]])) } : fs
      })
      console.log('fillFilterStuff filterStuff', this.filterStuff)
      return this.filterStuff
    },
    fillSearchStuff () {
      this.searchStuff = Object.assign({}, SearchStuffModel)
      this.searchStuff.fieldNames = TransactionTitlesModel.map(m => Object.fromEntries(Object.entries(m).filter(([key, value]) => {
        if (key === 'value' || key === 'filterType') { return value }
      }))) // .map(obj => obj.value)
      console.log('this.searchStuff:', this.searchStuff)
    },
    getItems () {
      const that = this
      if (this.role === 1) {
        var url = `${process.env.VUE_APP_LOYALTY_URL}api/transaction/all`
      }
      if (this.role === 2) {
        console.log('this.$store.state', this.$store.state)
        this.customerId = this.$store.state.client.id
         url = `${process.env.VUE_APP_LOYALTY_URL}api/transaction/customer/` + this.customerNumber
      }
      const filterStuff = this.filterStuff.filter(f => f.fieldValue.toString().length > 0 || Object.keys(f.fieldDate).length > 0 || Object.keys(f.fieldMoney).length > 0)
          .map(fs => Object.fromEntries(Object.entries(fs).filter(([key]) => [
          'fieldValue', 'fieldDate', 'fieldMoney', 'fieldType', 'fieldKey'].includes(key)
      )))
      console.log('getItems filterStuff', filterStuff)
      return this.webApi
          .post(
                url, { page: this.table_options.page, limit: this.table_options.itemsPerPage, filter: filterStuff, search: this.searchStuff }
          )
          .then(data => {
            this.total = data.count
            return data.items.map(item => {
              // set name instead id for service point in transaction table
              that.servicePoints.map(sp => {
                if (sp.pointId === item.servicePointId) {
                  Reflect.set(item, 'servicePointId', sp.placeHuman)
                }
              })
              // set name instead id for participant in transaction table
              that.participants.map(sp => {
                if (sp.userId === item.participantId) {
                  Reflect.set(item, 'participantId', sp.fullName)
                }
              })
              // set name instead id form campaign
              that.campaigns.map(sp => {
                if (sp.campaignId === item.campaignId) {
                  Reflect.set(item, 'campaignId', sp.name)
                    Reflect.set(item, 'customerId', sp.customerId)
                }
              })
              // set name instead code for product code (nomenclature code)
              that.products.filter(fProductCode => fProductCode.code === item.productCode && fProductCode.client === item.customerId).map(product => {
                Reflect.set(item, 'productCode', `${product.name} (${item.productCode})`)
              })
              return that.setItems(item)
})
          })
    },
    getResultValue (result) {
      return result.searched
    },
    onClearFilter (filter) {
      console.log('filter', filter)
      const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
      console.log('attrFilter', attrFilter)
      const newFilter = clearFilter(attrFilter, filter)
      console.log('newFilter', newFilter)
      localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
      this.onSetFilter()
    },
    onCloseFilter () {
      const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
      console.log('const filterStuff', filterStuff)
      this.filterStuff = filterStuff || this.fillFilterStuff()
      console.log('onCloseFilter this.filterStuff', this.filterStuff)
      this.filterDialogVisible = false
    },
    onCloseHeader () {
      this.headerDialogVisible = false
    },
    onOpenFilter () {
      this.filterDialogVisible = true
    },
    onOpenHeader () {
      const that = this
      this.headerDialogVisible = true
      this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/transaction/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
          .then(function (data) {
            console.log('header data', data)
            that.dialogHeaders = that.headerService.get_header(data)
          })
    },
    async onSetFilter () {
      this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || this.fillFilterStuff()
      // console.log('attrFilter', attrFilter)
      this.filterDialogVisible = false
      // this.filterStuff = new FilterStuff(attrFilter).items
      console.log('this.filterStuff', this.filterStuff)
      this.transactions = await this.getItems()
    },
    onSetHeader (value) {
      const that = this
      console.log('onSetHeader', value)
      this.dialogHeaders = value
      this.headerDialogVisible = false
      const headers = this.headerService.set_header("transaction", this.$store.state.client ? this.$store.state.client.id : "0", value)
      console.log('headers', headers)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
      that.headers = that.headerService.get_header_list(headers)
    },
    async onSubmit (result) {
      const searching = result.searched ? result.searched : result
      console.log('searching:', searching)
      if (searching.length !== 0) {
        // this.transactions = getObjectsForSearching(this.transactions, searching)
        this.searchStuff.fieldValue = searching
        this.transactions = await this.getItems()
      } else {
        this.searchStuff.fieldValue = ''
        await this.onSetFilter()
      }
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = getSearchedObjects(this.transactions, input)
      console.log('arr', arr)
      return arr
    },
    setItems (data) {
      return Reflect.construct(TransactionModel, [data])
    }
  }
}
</script>

<style scoped></style>
